import React, { Component } from 'react';
import ReactSelect from 'react-select'

class Select extends Component {

  onChange = ({ value }) => {
    this.props.onChange(value);
  };

  render() {
    const { options, label, value } = this.props;
    const optionForValue = options && options.find(o => o.value === value);
    return (
      <label className="Polarwind-Select__Label">
        <span className="Polarwind-Label Polarwind-Label--required">{label}</span>
        <ReactSelect {...this.props} onChange={this.onChange} value={optionForValue} />
      </label>
    );
  }

  static get defaultProps() {
    return {
      isSearchable: true,
      loadingMessage: 'Loading...',
      getOptionLabel: option => option.label,
      getOptionValue: option => option.value,
    };
  }
}

export default Select;
